var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{staticClass:"button--common",class:_vm.displayClass,attrs:{"disabled":_vm.disabled,"flat":_vm.flat,"hg-label":_vm.label,"type":_vm.type},on:{"click":_vm.handleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }